import PropTypes from "prop-types";
import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";

export default function FormInputnumber(props) {
  const {
    className = "",
    isControl = true,
    setting: { Controller, control, trigger, isSubmitted, isEdit = true } = {},
    data: {
      name,
      elValue,
      elChange,
      min = null,
      max = null,
      useGrouping = true,
      maxFractionDigits = 20,
      showButtons = false,
      placeholder = "",
      disabled = false,
    },
  } = props;

  const onChange = (type, e, field) => {
    let value = e.value;
    if (type === "blur") {
      value =
        e.target.value === ""
          ? null
          : Number(e.target.value.replaceAll(",", ""));
    }

    if (isControl) {
      field.onChange(value);

      if (isSubmitted) {
        trigger();
      } else {
        trigger(name);
      }
    } else {
      elChange({ name, value, options: props.data });
    }
  };

  const renderElement = ({ field, fieldState } = {}) => {
    let value = isControl ? field.value : elValue;

    return (
      <InputNumber
        id={name}
        className={classNames(
          { "p-invalid": isControl && fieldState.invalid },
          "w-full",
          className
        )}
        name={name}
        value={value ?? null}
        mode="decimal"
        min={min}
        max={max}
        useGrouping={useGrouping}
        maxFractionDigits={maxFractionDigits}
        showButtons={showButtons}
        placeholder={placeholder}
        onChange={(e) => onChange("change", e, field)}
        onBlur={(e) => onChange("blur", e, field)}
        disabled={!isEdit || disabled}
      />
    );
  };

  return (
    <>
      {isControl ? (
        <Controller
          name={name}
          control={control}
          render={({ field, fieldState }) =>
            renderElement({ field, fieldState })
          }
        />
      ) : (
        renderElement()
      )}
    </>
  );
}

FormInputnumber.propTypes = {
  className: PropTypes.string,
  data: PropTypes.shape({
    disabled: PropTypes.bool,
    elChange: PropTypes.func,
    elValue: PropTypes.number,
    max: PropTypes.number,
    maxFractionDigits: PropTypes.number,
    min: PropTypes.number,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    showButtons: PropTypes.bool,
    useGrouping: PropTypes.bool,
  }).isRequired,
  isControl: PropTypes.bool,
  setting: PropTypes.shape({
    control: PropTypes.object,
    Controller: PropTypes.elementType,
    isEdit: PropTypes.bool,
    isSubmitted: PropTypes.bool,
    trigger: PropTypes.func,
  }),
};
